import { FlexExtended } from '@dealstack/frontend/shared/components/Flex/FlexExtended';
import { Flex, FlexProps } from '@mantine/core';
import styled, { css } from 'styled-components';
import type { RefAttributes } from 'react';
import { FlexExtendedProps } from '@dealstack/frontend/shared/components/Flex/FlexExtended.types';

export const MessagesListContainer = styled(FlexExtended).attrs(
	(props: FlexExtendedProps) => props
)`
	min-width: 20rem;
	height: 100%;
	padding: 0.5rem;
	border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
`;

type MessageContainerProps = FlexExtendedProps & {
	selected?: boolean;
};
export const MessageContainer = styled(FlexExtended).attrs<Partial<MessageContainerProps>>(
	(props: MessageContainerProps) => props
)`
	border: 1px solid transparent;
	margin-top: 0.25rem;
	margin-bottom: 0.25rem;
	transition: background-color 0.2s ease-out;

	&:hover {
		cursor: pointer;
	}

	${({ selected }) =>
		selected
			? css`
					background-color: ${({ theme }) => theme.v3.colors.blue[0]};
					border-color: ${({ theme }) => theme.v3.colors.blue[6]};

					&:hover {
						cursor: default;
					}
				`
			: css`
					&:hover {
						background-color: ${({ theme }) => theme.v3.colors.gray[0]};
					}

					&:active {
						background-color: ${({ theme }) => theme.v3.colors.gray[2]};
					}
				`}
`;

type VirtualRowContainerProps = {
	$start: number;
};

export const VirtualRowContainer = styled.div<VirtualRowContainerProps>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	transform: translateY(${(props) => props.$start}px);
`;

export const MessagesListScrollContainer = styled(Flex)<FlexProps & RefAttributes<HTMLDivElement>>`
	overflow: auto;
	height: 100%;
`;

type VirtualizerContainerProps = {
	$totalSize: number;
};

export const VirtualizerContainer = styled.div<VirtualizerContainerProps>`
	height: ${(props) => props.$totalSize}px;
	width: 100%;
	position: relative;
`;
